import {useTheme} from "../../../common/ProjectThemeProvider";
import React, {useEffect, useState} from 'react';
import {AppInterface, ThemedButton, ThemedDialog} from "../../index";
import {GenRouteUrls, Keys, ModuleFieldsData, ModuleRouteUrls, Modules, ReqUrls} from "../../config/AppConfig";
import {
    checkNullArr,
    checkNullStr,
    getDefStr,
    getJsonValue,
    getJsonValueFromNestedKeys,
    isBoolTrue,
    sliceArr,
    vhToPx
} from "../../../common/fusion-ui/utils/ReactUtils";
import {printError, printLog, sendRequest} from "../../utils/AppUtils";
import {useToast} from "../../../common/fusion-ui/provider/ToastProvider";
import {Anchor, Avatar, Flexbox, GridBox, Label, LoadingSection, Section} from "../../../common/fusion-ui"
import {CssVariant, DefStrNA, Messages} from "../../../common/fusion-ui/config/FusionConfig";
import {useConfig} from "../../context/ConfigProvider";
import {AnimationType, FramerAnimator} from "../../../common/fusion-ui/animation/FramerAnimator";

const ResourcesPage = React.memo(({
                                      fromSearchPage = false,
                                      panelsData = {},
                                      showControls = true,
                                  }) => {
    const TAG = "ResourcesPage";

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isConfigTrue, updateConfig} = useConfig();
    // const {isScreenXs, isScreenSm, isScreenMd, isScreenResizing} = useScreenSize();

    const animator = new FramerAnimator();

    const module_res = Modules.Resources;
    const module_pub = Modules.Publication;
    const module_doc = Modules.Documents;
    const module_cs = Modules.CaseStudy;
    const module_vid = Modules.Videos;
    const module_img = Modules.Images;
    const module_link = Modules.UsefulLinks;

    const md_pub = ModuleFieldsData[module_pub];
    const mf_doc = ModuleFieldsData[module_doc];
    const mf_cs = ModuleFieldsData[module_cs];
    const mf_vid = ModuleFieldsData[module_vid];
    const mf_img = ModuleFieldsData[module_img];
    const mf_link = ModuleFieldsData[module_link];

    const Fields = {
        isDataLoading: 'isDataLoading',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFound: 'isDataFound',
        isDataFetched: 'isDataFetched',

        isDataLoading_pub: 'isDataLoading_pub',
        isDataFound_pub: 'isDataFound_pub',
        dataLoadingMsg_pub: 'dataLoadingMsg_pub',

        isDataLoading_cs: 'isDataLoading_cs',
        isDataFound_cs: 'isDataFound_cs',
        dataLoadingMsg_cs: 'dataLoadingMsg_cs',

        isDataLoading_link: 'isDataLoading_link',
        isDataFound_link: 'isDataFound_link',
        dataLoadingMsg_link: 'dataLoadingMsg_link',

        isDataLoading_img: 'isDataLoading_img',
        isDataFound_img: 'isDataFound_img',
        dataLoadingMsg_img: 'dataLoadingMsg_img',

        isDataLoading_vid: 'isDataLoading_vid',
        isDataFound_vid: 'isDataFound_vid',
        dataLoadingMsg_vid: 'dataLoadingMsg_vid',

        isDataLoading_doc: 'isDataLoading_doc',
        isDataFound_doc: 'isDataFound_doc',
        dataLoadingMsg_doc: 'dataLoadingMsg_doc',

        publicationList: 'publicationList',
        caseStudyRecordList: 'caseStudyRecordList',
        usefulLinkRecordList: 'usefulLinkRecordList',
        imageRecordList: 'imageRecordList',
        videoRecordList: 'videoRecordList',
        docRecordList: 'docRecordList',

        videoPanelShowVideoDialog: 'videoPanelShowVideoDialog',
        videoPanelDialogContent: 'videoPanelDialogContent',
    };
    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        if (!isBoolTrue(fromSearchPage)) {
            updateConfig(Keys.config_ShowTabBar, true);
            updateConfig(Keys.config_TabBarTab, module_res);
            updateConfig(Keys.tracker_currPageModule, module_res);
            updateConfig(Keys.tracker_currPageTag, TAG);
        }
    }, [fromSearchPage]);

    useEffect(() => {
        fetchPageData();
    }, [fromSearchPage, panelsData]);

    return (<>
        {isBoolTrue(fromSearchPage) ? createPanels() : createPage()}
        {createVideoDisplayDialog()}
    </>);

    function createPage() {
        return <AppInterface>
            <div className={`m-0 p-0 my-2 w-100`}>
                {/*header*/}
                <div className={`m-0 p-0 mb-2`}>
                    {/*recom btn*/}
                    {<ThemedButton
                        className={'w-auto fs-sm text-nowrap fw-semi-bold'}
                        outlined={true}
                        sleek={true}
                        m={1}
                        disabled={isFieldTrue(Fields.isDataLoading)}
                        text={`Recommend a Resource`}
                        variant={theme.primaryBlue}
                        href={GenRouteUrls.res_recomPage}
                    />}
                </div>

                {/*panels*/}
                {createPanels()}
            </div>
        </AppInterface>
    }

    function createPanels() {
        return <div>
            <div className={'m-0 p-0 w-100 h-100 position-relative'}>
                {animator.setAnimationType(AnimationType.SLIDE_UP).render(
                    <GridBox className={'px-2'} sm={12} md={4} gap={1}>
                        {/* pub-section */}
                        <Section className={"px-1 p-0 app-section hover"} height={'20rem'} borderColor={theme.text20}>
                            {createHeaderLabel(module_pub)}
                            <div
                                className={'overflow-y-auto overflow-x-hidden px-2 py-2 rounded-3 mt-1 pb-1'}
                                style={{maxHeight: '17rem'}}>
                                {createLoadingPanel(Fields.isDataFound_pub, Fields.isDataLoading_pub, Fields.dataLoadingMsg_pub)}

                                {(!isFieldTrue(Fields.isDataLoading_pub) && isFieldTrue(Fields.isDataFound_pub)) &&
                                    <div>
                                        {getPubRecordList().map((item, index) => {
                                            let pub_recordId = getJsonValue(item, md_pub.recordId.column)
                                            return createLinkForList({
                                                link: `${GenRouteUrls.pub_internalPage}${pub_recordId}`,
                                                title: getJsonValue(item, md_pub.title.column)
                                            })
                                        })}
                                        {createFooterMoreLinkButton(module_pub)}
                                    </div>}
                            </div>
                        </Section>

                        {/* doc-section */}
                        <Section className={"px-1 p-0 app-section hover"} height={'20rem'} borderColor={theme.text20}>
                            {createHeaderLabel(module_doc)}
                            <div
                                className={'overflow-y-auto overflow-x-hidden px-2 py-2 rounded-3 mt-1 pb-1'}
                                style={{maxHeight: '17rem'}}>
                                {createLoadingPanel(Fields.isDataFound_doc, Fields.isDataLoading_doc, Fields.dataLoadingMsg_doc)}

                                {(!isFieldTrue(Fields.isDataLoading_doc) && isFieldTrue(Fields.isDataFound_doc)) &&
                                    <div>
                                        {getDocRecordList().map((item, index) => {
                                            let doc_recordId = getJsonValue(item, mf_doc.recordId.column)
                                            return createLinkForList({
                                                link: `${GenRouteUrls.doc_internalPage}${doc_recordId}`,
                                                title: getJsonValue(item, mf_doc.title.column)
                                            })
                                        })}
                                        {createFooterMoreLinkButton(module_doc)}
                                    </div>}
                            </div>
                        </Section>

                        {/* cs-section */}
                        <Section className={"px-1 p-0 app-section hover"} height={'20rem'} borderColor={theme.text20}>
                            {createHeaderLabel(module_cs)}
                            <div
                                className={'overflow-y-auto overflow-x-hidden px-2 py-2 rounded-3 mt-1 pb-1'}
                                style={{maxHeight: '17rem'}}>
                                {createLoadingPanel(Fields.isDataFound_cs, Fields.isDataLoading_cs, Fields.dataLoadingMsg_cs)}

                                {(!isFieldTrue(Fields.isDataLoading_cs) && isFieldTrue(Fields.isDataFound_cs)) &&
                                    <div>
                                        {getCsRecordList().map((item, index) => {
                                            let cs_recordId = getJsonValue(item, mf_cs.recordId.column)
                                            return createLinkForList({
                                                link: `${GenRouteUrls.cs_internalPage}${cs_recordId}`, title: getJsonValue(item, mf_cs.title.column)
                                            })
                                        })}
                                        {createFooterMoreLinkButton(module_cs)}
                                    </div>}
                            </div>
                        </Section>

                        {/* video-section */}
                        <Section className={"px-1 p-0 app-section hover"} height={'20rem'} borderColor={theme.text20}>
                            {createHeaderLabel(module_vid)}
                            <div
                                className={'overflow-y-auto overflow-x-hidden px-2 py-2 rounded-3 mt-1 pb-1'}
                                style={{maxHeight: '17rem'}}>
                                {createLoadingPanel(Fields.isDataFound_vid, Fields.isDataLoading_vid, Fields.dataLoadingMsg_vid)}

                                {(!isFieldTrue(Fields.isDataLoading_vid) && isFieldTrue(Fields.isDataFound_vid)) &&
                                    <div>
                                        {getVideoRecordList().map((item, index) => {
                                            return (checkNullStr(getJsonValue(item, mf_vid.url.column)) && checkNullStr(getJsonValue(item, mf_vid.title.column))) &&
                                                createLinkForList({
                                                    link: `https://www.youtube.com/watch?v=${getJsonValue(item, mf_vid.url.column)}`,
                                                    title: getJsonValue(item, mf_vid.title.column),
                                                    simple: true,
                                                    onClick: ((e) => {
                                                        log('onClick.link:', getJsonValue(item, mf_vid.url.column), 'title:', getJsonValue(item, mf_vid.title.column));
                                                        e.preventDefault();

                                                        updateField(Fields.videoPanelDialogContent, {
                                                            id: getJsonValue(item, mf_vid.url.column),
                                                            title: getJsonValue(item, mf_vid.title.column),
                                                            onHide: () => {

                                                            },
                                                        });
                                                        updateField(Fields.videoPanelShowVideoDialog, true);
                                                    })
                                                })
                                        })}
                                        {createFooterMoreLinkButton(Modules.Videos)}
                                    </div>}
                            </div>
                        </Section>

                        {/* img-section */}
                        <Section className={"px-1 p-0 app-section hover"} height={'20rem'} borderColor={theme.text20}>
                            {createHeaderLabel(module_img)}
                            <div
                                className={'overflow-y-auto overflow-x-hidden rounded-3 px-2'}
                                style={{maxHeight: '17rem'}}>
                                {createLoadingPanel(Fields.isDataFound_img, Fields.isDataLoading_img, Fields.dataLoadingMsg_img)}

                                {(!isFieldTrue(Fields.isDataLoading_img) && isFieldTrue(Fields.isDataFound_img)) &&
                                    <div>
                                        <GridBox className={'px-1'} sm={12} md={6} gap={1}>
                                            {getImageRecordList().map((item, index) => {
                                                return <Avatar
                                                    key={index + 'awesome'}
                                                    wrapperClassName={''}
                                                    imgClassName={'rounded-3'}
                                                    width={'100%'}
                                                    height={'130px'}
                                                    circular={false}
                                                    previewDialogWidthClass={'col-sm-10 col-md-8'}
                                                    showFullPreviewDialog={true}
                                                    // defAvatarImg={'https://cdn.pixabay.com/photo/2017/09/30/18/53/prognosis-icon-2803190_1280.png'}
                                                    // defAvatarImg={'https://cdn.pixabay.com/photo/2020/12/18/00/43/doctor-5840874_1280.png'}
                                                    defAvatarImg={'https://cdn.pixabay.com/photo/2016/03/21/20/05/image-1271454_1280.png'}
                                                >
                                                    {getJsonValue(item, mf_img.title.column)}
                                                </Avatar>
                                            })}
                                        </GridBox>
                                        {createFooterMoreLinkButton(module_img)}
                                    </div>}
                            </div>
                        </Section>

                        {/* link-section */}
                        <Section className={"px-1 p-0 app-section hover"} height={'20rem'} borderColor={theme.text20}>
                            {createHeaderLabel(module_link)}
                            <div
                                className={'overflow-y-auto overflow-x-hidden px-2 py-2 rounded-3 mt-1 pb-1'}
                                style={{maxHeight: '17rem'}}>
                                {createLoadingPanel(Fields.isDataFound_link, Fields.isDataLoading_link, Fields.dataLoadingMsg_link)}

                                {(!isFieldTrue(Fields.isDataLoading_link) && isFieldTrue(Fields.isDataFound_link)) &&
                                    <div>
                                        {getLinkRecordList().map((item, index) => {
                                            let link_recordId = getJsonValue(item, mf_link.recordId.column)
                                            return createLinkForList({
                                                link: `${GenRouteUrls.link_internalPage}${link_recordId}`,
                                                title: getJsonValue(item, mf_link.title.column)
                                            })
                                        })}
                                        {createFooterMoreLinkButton(module_link)}
                                    </div>}
                            </div>
                        </Section>
                    </GridBox>,
                )}
            </div>
        </div>
    }

    //======================UI Functions start=====================
    function createHeaderLabel(module, moduleUrl) {
        return <div className={'w-100 m-0 p-0 mt-1'}>
            <ThemedButton
                className={`text-nowrap fw-semi-bold ${isBoolTrue(showControls) ? 'cursor-pointer' : 'cursor-default'}`}
                width={'100%'}
                text={module}
                sleek={true}
                outlined={true}
                variant={theme.primaryBlue}
                color={isBoolTrue(showControls) ? theme.primaryBlue : theme.text}
                bgColor={isBoolTrue(showControls) ? theme.primaryBlue20 : theme.text10}
                hoverBgColor={isBoolTrue(showControls) ? theme.primaryBlue : theme.text10}
                hoverColor={isBoolTrue(showControls) ? theme.textWhite : theme.text}
                borderWidth={isBoolTrue(showControls) ? '1px' : 0}
                disableRipple={!isBoolTrue(showControls)}
                href={isBoolTrue(showControls) ? getDefStr(moduleUrl, ModuleRouteUrls[module]) : ''}
                onLinkClick={(e) => {
                    if (isBoolTrue(showControls)) e.preventDefault();
                }}
                onClick={(e) => {
                    if (isBoolTrue(showControls)) {
                        e.preventDefault();
                        window.location.href = getDefStr(moduleUrl, ModuleRouteUrls[module]);
                    }
                }}
            />
        </div>
    }

    function createLinkForList({link, title, simple, target = '', onClick, rest = {}}) {
        return <div key={link + title + simple + target} className={'m-0 p-0 mb-2x'}>
            <span className={'d-flex flex-nowrap w-auto fd-row'}>
                <span className={'fw-bold select-none cursor-default '}
                      style={{color: theme.text, marginTop: '-.1rem'}}>
                    <i className={'bi bi-dash'}/>
                    <span>{"   "}</span>
                </span>

                <span>
                    <Anchor className={'m-0 p-0 fw-semi-boldx text-wrap'}
                            textAt={'start'}
                            href={link}
                            target={target}
                            simple={isBoolTrue(simple)}
                            style={{lineHeight: 1.3}}
                            onClick={onClick}
                            {...rest}
                    >
                        {title}
                    </Anchor>
                </span>
            </span>
            <hr className={'m-0 m-0 my-1'} style={{borderColor: theme.text10}}/>
        </div>
    }

    function createFooterMoreLinkButton(module, moduleUrl) {
        return isBoolTrue(showControls) && <Flexbox
            className={'mt-1 w-100'}
            justifyAt={'end'}>
            <Anchor className={'fs-sm fw-semi-bold'}
                    textAt={'start'}
                    href={getDefStr(moduleUrl, ModuleRouteUrls[module])}
                    style={{lineHeight: 1.3}}
                    simple={true}
                    onClick={(e) => {
                        // e.preventDefault();
                        // window.location.href = getDefStr(moduleUrl, ModuleRouteUrls[module]);
                    }}>
                More {module}
            </Anchor>
        </Flexbox>
    }

    function createVideoDisplayDialog() {
        return <ThemedDialog
            className={"rounded-6 p-0 m-0"}
            titleClassName={'fs-lg mb-2'}
            widthClass={'col-sm-10 col-md-7'}
            open={isFieldTrue(Fields.videoPanelShowVideoDialog)}
            title={"Video"}
            showClose={true}
            showFooter={false}
            closeOnEscape={true}
            closeOnOutsideClick={true}
            onHide={() => {
                const onHide = getJsonValue(getField(Fields.videoPanelDialogContent), 'onHide');
                if (onHide) onHide();
                updateField(Fields.videoPanelDialogContent, {});
                updateField(Fields.videoPanelShowVideoDialog, false);
            }}>
            <div className={'px-3'}>
                <div className={''}>
                    {checkNullStr(getJsonValue(getField(Fields.videoPanelDialogContent), 'id')) ? <iframe
                        width="100%"
                        height={vhToPx('65vh') + 'px'}
                        src={`https://www.youtube.com/embed/${getJsonValue(getField(Fields.videoPanelDialogContent), 'id') + ''}`}
                        allowFullScreen/> : <span>No video present</span>}
                </div>
                <div className={'px-3x mb-2'}>
                    <Label className={'fw-semi-bold'}>
                        {(getJsonValue(getField(Fields.videoPanelDialogContent), 'title', DefStrNA)) + ''}
                    </Label>
                </div>
            </div>
        </ThemedDialog>
    }

    function createLoadingPanel(dataFoundKey, loadingKey, msgKey) {
        return <LoadingSection
            labelClassName={'m-2 w-100 fs-normal'}
            heightClass={75}
            color={theme.text70}
            success={isFieldTrue(dataFoundKey)}
            loading={isFieldTrue(loadingKey)}
            msg={getField(msgKey)}
        />
    }

    //======================UI Functions end=====================

    //======================Request Functions start=====================
    async function fetchPageData() {
        const fun = 'fetchPageData:';
        if (!isFieldTrue(Fields.isDataFetched)) {
            updateField(Fields.isDataFetched, true);


            // updateField(Fields.publicationList, PubPanel_Data);
            // updateField(Fields.caseStudyRecordList, CsPanel_Data);
            // updateField(Fields.docRecordList, DocPanel_Data);
            // updateField(Fields.usefulLinkRecordList, LinkPanel_Data);
            // updateField(Fields.imageRecordList, ImgPanel_Data);
            // updateField(Fields.videoRecordList, VidPanel_Data);

            const data = await Promise.all([
                //pub
                fetchSingleModuleData({
                    moduleName: module_pub,
                    reqUrl: ReqUrls.pub__mainPage_fetch_recordList,
                    listKey: Fields.publicationList,
                    loadingKey: Fields.isDataLoading_pub,
                    dataFoundKey: Fields.isDataFound_pub,
                    msgKey: Fields.dataLoadingMsg_pub,
                }),
                //doc
                fetchSingleModuleData({
                    moduleName: module_doc,
                    reqUrl: ReqUrls.doc__mainPage_fetch_recordList,
                    listKey: Fields.docRecordList,
                    loadingKey: Fields.isDataLoading_doc,
                    dataFoundKey: Fields.isDataFound_doc,
                    msgKey: Fields.dataLoadingMsg_doc,
                }),
                //cs
                fetchSingleModuleData({
                    moduleName: module_cs,
                    reqUrl: ReqUrls.cs__mainPage_fetch_recordList,
                    listKey: Fields.caseStudyRecordList,
                    loadingKey: Fields.isDataLoading_cs,
                    dataFoundKey: Fields.isDataFound_cs,
                    msgKey: Fields.dataLoadingMsg_cs,
                }),
                //vid
                fetchSingleModuleData({
                    moduleName: module_vid,
                    reqUrl: ReqUrls.vid__mainPage_fetch_recordList,
                    listKey: Fields.videoRecordList,
                    loadingKey: Fields.isDataLoading_vid,
                    dataFoundKey: Fields.isDataFound_vid,
                    msgKey: Fields.dataLoadingMsg_vid,
                }),
                // img
                fetchSingleModuleData({
                    moduleName: module_img,
                    reqUrl: ReqUrls.img__mainPage_fetch_recordList,
                    listKey: Fields.imageRecordList,
                    loadingKey: Fields.isDataLoading_img,
                    dataFoundKey: Fields.isDataFound_img,
                    msgKey: Fields.dataLoadingMsg_img,
                }),
                //link
                fetchSingleModuleData({
                    moduleName: module_link,
                    reqUrl: ReqUrls.link__mainPage_fetch_recordList,
                    listKey: Fields.usefulLinkRecordList,
                    loadingKey: Fields.isDataLoading_link,
                    dataFoundKey: Fields.isDataFound_link,
                    msgKey: Fields.dataLoadingMsg_link,
                }),
            ]);
        }
    }


    async function fetchSingleModuleData({moduleName, reqUrl, listKey, loadingKey, dataFoundKey, msgKey}) {
        const fun = 'fetchSingleModuleData:';
        try {
            updateField(dataFoundKey, false);
            updateField(loadingKey, true);
            updateField(msgKey, '');

            if (isBoolTrue(fromSearchPage)) {
                updateData(getJsonValue(panelsData, moduleName, []));
            } else {
                sendRequest({
                    reqUrl: reqUrl,
                    onFetched: ((fetchedData) => {
                        log(fun, 'moduleName:', moduleName, 'fetchedData:', fetchedData);
                        let recordList = getJsonValueFromNestedKeys(fetchedData, ['data', 'recordList'], []);
                        if (!checkNullArr(recordList)) recordList = getJsonValue(fetchedData, 'data', []);
                        updateData(recordList);
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        toast(`Couldn't load data for ${moduleName}!`, CssVariant.danger);
                        updateField(loadingKey, false);
                        updateField(dataFoundKey, false);
                        updateField(msgKey, Messages.fetchError);
                    }),
                });
            }
        } catch (error) {
            logErr(fun, error);
            toast(`Couldn't load data for ${moduleName}!`, CssVariant.danger);
            updateField(loadingKey, false);
            updateField(dataFoundKey, false);
            updateField(msgKey, Messages.fetchError);
        }

        function updateData(recordList) {
            recordList = sliceArr(recordList, 0, 10);
            log(fun, 'moduleName:', moduleName, 'fetchedData.recordList:', recordList);

            const success = moduleName == module_img ? checkNullArr(getImageRecordList(recordList)) : checkNullArr(recordList);
            updateField(dataFoundKey, success);
            if (success) {
                // toast(`Successfully fetched data for ${moduleName}.`, CssVariant.success)
                updateField(listKey, recordList);
            } else {
                updateField(msgKey, Messages.noDataFound);
                // toast(`Data not found for ${moduleName}!`, CssVariant.danger);
            }
            updateField(loadingKey, false);
        }
    }


    //======================Util Functions start=====================
    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    function getPubRecordList() {
        return checkNullArr(getField(Fields.publicationList)) ? getField(Fields.publicationList) : [];
    }

    function getCsRecordList() {
        return checkNullArr(getField(Fields.caseStudyRecordList)) ? getField(Fields.caseStudyRecordList) : [];
    }

    function getLinkRecordList() {
        return checkNullArr(getField(Fields.usefulLinkRecordList)) ? getField(Fields.usefulLinkRecordList) : [];
    }

    function getImageRecordList(list = []) {
        list = checkNullArr(list) ? list : getField(Fields.imageRecordList);
        list = checkNullArr(list) ? list : [];
        if (checkNullArr(list)) {
            const imgList = [];
            list.forEach(record => {
                const imageList = getJsonValue(record, mf_img.imageList.column, []);
                // log('getImageRecordList.imageRecordList.for.record.imageList:', imageList);
                if (checkNullArr(imageList, true)) {
                    for (const imgObj of imageList) {
                        if (checkNullStr(getJsonValue(imgObj, mf_img.title.column))) {
                            // log('getImageRecordList.imageRecordList.for.record.imageList.img:', img);
                            imgList.push({
                                ...record,
                                [mf_img.title.column]: getJsonValue(imgObj, mf_img.title.column)
                            });
                        }
                    }
                }
            });
            // log('getImageRecordList.imageRecordList.imgList:', imgList);
            return imgList;
        } else {
            return []
        }
    }

    function getVideoRecordList() {
        return checkNullArr(getField(Fields.videoRecordList)) ? getField(Fields.videoRecordList) : [];
    }

    function getDocRecordList() {
        return checkNullArr(getField(Fields.docRecordList)) ? getField(Fields.docRecordList) : [];
    }

    //======================Util Functions end=====================
});
export default ResourcesPage;
